import { BillingRepository } from "../../../repositories/billingRepository"
import { UseCase } from "../../useCase"
import { ExportInvoicePaymentsRequest } from "./request"
import { ExportInvoicePaymentsResponse } from "./response"

export class ExportInvoicePaymentsUseCase
	implements UseCase<ExportInvoicePaymentsRequest, ExportInvoicePaymentsResponse>
{
	private _repository
	constructor({ BillingRepository }: { BillingRepository: BillingRepository }) {
		this._repository = BillingRepository
	}
	exec(filter: ExportInvoicePaymentsRequest): Promise<ExportInvoicePaymentsResponse> {
		return this._repository.exportInvoicePayments(filter)
	}
}
